import { Component, Input, OnDestroy, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'ui-container',
  templateUrl: './ui-container.component.html',
  styleUrls: ['./ui-container.component.scss']
})
export class UiContainerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() component: any;
  @Input() parent;

  public children;
  @ViewChild('childrenWrapper') childrenWrapper: ElementRef;

  constructor(
    private _renderer: Renderer2
  ) { }

  ngOnInit(): void {
    //console.log("UI CONTAINER CHILDREN", this.component.children)
  }

  ngAfterViewInit(): void {
    if (this.childrenWrapper && this.childrenWrapper.nativeElement.children.length > 0) {
      this.children = this.childrenWrapper.nativeElement.children;
      const gridClass = this.component.componentConfig.styles.find(x => x.cssClass.includes("cs--grid"));
      if (gridClass != undefined) {
        this._renderer.addClass(this.childrenWrapper.nativeElement, "cs--grid");
        this._renderer.addClass(this.childrenWrapper.nativeElement, gridClass.cssClass);
        for (let child in this.children) {
          if (this.children[child] != undefined && typeof this.children[child] == 'object') {
            this._renderer.addClass(this.children[child], `child-${Number(child) + 1}`);
          }
        }
      }
    } 
  }

  ngOnDestroy(): void {
    // this.unsubscribe$.next();
    // this.unsubscribe$.complete();
  }

}
